<template>
    <div>
        
            <b-form>
                
                <div class="animated fadeIn">

                    <b-nav tabs v-if="!selectedItem.id || selectedItem.id <= 0">
                        <b-nav-item :active="tabInternalReferral=='E'" @click="changeTabInternalReferral('E')">Indicação Externa</b-nav-item>
                        <b-nav-item :active="tabInternalReferral=='I'" @click="changeTabInternalReferral('I')">Indicação Interna</b-nav-item>
                    </b-nav>
                    
                    <!--
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                                <b-button variant="outline-primary" @click="myReferral">Indicação Interna</b-button>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto" class="">
                            <b-form-group>
                                <b-button variant="outline-primary" @click="myReferral">Indicação Interna</b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    -->
                    
                    <hr v-if="!selectedItem.id || selectedItem.id <= 0">
                    
                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Cliente"
                            label-for="companyName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class='fa fa-building-o'></i>
                                    </span>
                                    </div>
                                         <b-form-input id="companyName" v-model="selectedItem.companyName" type="text" style="text-transform: uppercase" ></b-form-input>
                            </b-input-group>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Contato"
                            label-for="contactName"
                            :label-cols="3"
                            :horizontal="true">
                            <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class='fa fa-vcard-o'></i>
                                    </span>
                                    </div>
                                        <b-form-input id="contactName" v-model="selectedItem.contactName" type="text" style="text-transform: uppercase" :class="contactNameClass"></b-form-input>
                            </b-input-group>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            :description="contactEmailDescription"
                            label="E-mail"
                            label-for="contactEmail"
                            :label-cols="3"
                            :horizontal="true">
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class='fa fa-envelope'></i>
                                    </span>
                                    </div>
                                    <b-form-input id="contactEmail" v-model="selectedItem.contactEmail" type="email" style="text-transform: lowercase" :class="contactEmailClass"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group label="Telefone" 
                            description=""
                            label-for="phone"
                            :label-cols="3"
                            :horizontal="true"
                            >
                            <b-row>
                                <b-col md=5>
                                    <b-input-group>
                                        <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class='fa fa-phone'></i>
                                        </span>
                                        </div>
                                        <masked-input
                                        type="tel"
                                        name="phone"
                                        class="form-control"
                                        v-model="selectedItem.contactPhone"
                                        :mask="['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                        :guide="true"
                                        :class="contactPhoneClass"
                                        >
                                        </masked-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                           
                            </b-form-group>
                        </b-form>
                        </b-col>
                    </b-row>


                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Descrição do serviço"
                            label-for="serviceDescription"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-textarea
                            id="textarea"
                            v-model="selectedItem.serviceDescription"
                            placeholder=""
                            rows="3"
                            :class="serviceDescriptionClass"
                            ></b-form-textarea>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                        <b-form>
                            <b-form-group
                            description=""
                            label="Observação"
                            label-for="notes"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-textarea
                            id="textarea"
                            v-model="selectedItem.notes"
                            placeholder=""
                            rows="3"                            
                            ></b-form-textarea>
                        </b-form-group>          
                        </b-form>
                        </b-col>
                    </b-row>

                    <b-row v-if="selectedItem.groupUser && selectedItem.groupUser.user">
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            label="Indicado por"
                            label-for="groupuser"
                            :label-cols="3"
                            :horizontal="true">
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class='fa fa-user-circle-o'></i>
                                    </span>
                                    </div>
                                    <b-form-input id="groupuser" v-model="selectedItem.groupUser.user.name" type="text" readonly></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>

                    <b-row v-if="selectedItem.status">
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            label="Status"
                            label-for="status"
                            :label-cols="3"
                            :horizontal="true">
                                <b-input-group>
                                    <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class='fa fa-indent'></i>
                                    </span>
                                    </div>
                                    <b-form-input id="status" v-model="selectedItem.status.name" type="text" readonly></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>

                    <div  v-if="(selectedItem.referralValue && selectedItem.referralValue > 0) || (selectedItem.monthlyValue && selectedItem.monthlyValue > 0)">
                        <hr>

                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Valor do contrato/inscrição"
                                label-for="referralValue"
                                :label-cols="3"
                                :horizontal="true">
                            
                                <b-row>
                                    <b-col><b-form-input v-model="selectedItem.referralValue" id="referralValue" type="number" readonly></b-form-input></b-col>
                                    <b-col  cols="auto">Comissão: </b-col>
                                    <b-col><b-form-input v-model="selectedItem.comissionValue" id="value" type="number" readonly></b-form-input></b-col>
                                    <b-col  cols="auto">Data: </b-col>
                                    <b-col><b-form-input v-model="selectedItem.referralDate" type="date" id="referralDate" readonly></b-form-input></b-col>
                                </b-row>

                            </b-form-group>          
                            </b-form>
                            </b-col>
                        </b-row>

                        <b-row >
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Valor mensal"
                                label-for="monthlyValue"
                                :label-cols="3"
                                :horizontal="true">
                            
                                <b-row>
                                    <b-col><b-form-input v-model="selectedItem.monthlyValue" id="monthlyValue" type="number" readonly></b-form-input></b-col>
                                    <b-col  cols="auto">Comissão: </b-col>
                                    <b-col><b-form-input v-model="selectedItem.monthlyComissionValue" id="value" type="number" readonly></b-form-input></b-col>
                                    <b-col  cols="auto">Data: </b-col>
                                    <b-col><b-form-input v-model="selectedItem.monthlyDate" type="date" id="monthlyDate" readonly></b-form-input></b-col>
                                </b-row>

                            </b-form-group>          
                            </b-form>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col md="12">
                            <b-form>
                                <b-form-group
                                description=""
                                label="Dia de pagamento"
                                label-for="paymentDay"
                                :label-cols="3"
                                :horizontal="true">
                            
                                <b-row>
                                    <b-col md="2"><b-form-input v-model="selectedItem.paymentDay" id="paymentDay" type="number" readonly></b-form-input></b-col>                                
                                </b-row>

                            </b-form-group>          
                            </b-form>
                            </b-col>
                        </b-row>
                    </div>

                    <hr>

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description="Selecione o associado responsável pelo atendimento da indicação"
                            label="Associado indicado"
                            label-for="serviceUser"
                            :label-cols="3"
                            :horizontal="true">
                            <b-form-select id="serviceUser"
                                v-model="selectedItem.serviceGroupUserId"
                                :plain="true"
                                :options="selectGroupUserDDL"
                                :value="[null,'c']">
                            </b-form-select>
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>



                    <b-input-group class="mb-4">
                        <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                    </b-input-group>
                
                    
                        
                </div>
            </b-form>

            <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()" :disabled="saving"><i class="fa fa-check"></i><span>Salvar Indicação</span></b-button>
                    
            </div>
    </div>  

</template>


<script>
import Vue from 'vue'
import axios from "axios";
import MaskedInput from 'vue-text-mask'

/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

  const newItem = {
                    serviceDescription: '',
                    st: 'A',
                    companyName: '',
                    contactName: '',
                    contactPhone: '',
                    contactEmail: '',
                    indicator: '',
                    notes: ''
                }

export default {
    name: 'documentTemplatePdfComponent',
    props: {
       item: {},
       companyId: 0
    },
    components: {
      MaskedInput
    },
    computed: {
      selectedItem() {
        return this.item
      },
      selectGroupUserDDL: function() {
          var list = [...this.groupUserDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '' })
          return list
      },
    },
    data: () => {
        return {
            saving: false,
            tabInternalReferral: 'E',
            contactNameClass: '',
            contactEmailClass: '',
            contactEmailDescription: '',
            contactPhoneClass: '',
            serviceDescriptionClass: '',

            groupUserDDL: [],
            errorMessage: "",
            selectedDocument: null,
            documentModal: false,
            documentTemplateId: null
        }
    },
    methods: {
        changeTabInternalReferral(internalOrExternal) {
            this.tabInternalReferral = internalOrExternal
            if(internalOrExternal == 'I') {
                this.selectedItem.contactId = this.$store.state.currentUser.id
                this.selectedItem.contactName = this.selectedItem.contactName && this.selectedItem.contactName.length > 0 ? this.selectedItem.contactName : this.$store.state.currentUser.name
                this.selectedItem.contactEmail = this.selectedItem.contactEmail && this.selectedItem.contactEmail.length > 0 ? this.selectedItem.contactEmail : this.$store.state.currentUser.email
                this.selectedItem.contactPhone = this.selectedItem.contactPhone && this.selectedItem.contactPhone.length > 0 ? this.selectedItem.contactPhone : this.$store.state.currentUser.phone
            }
            else {
                this.selectedItem.contactId = null
            }
            
        },
        async saveItem(currentItem) {

            var s = this;
            var postData = {...currentItem};

            postData["companyId"] = s.companyId
            postData["uid"] = this.$store.state.currentUser.id,
            postData["sid"] = this.$store.state.currentUser.sid

            this.saving = true
            await axios.post(
                this.$store.state.ws_url + "/franchise/referral",
                postData
            ).then(function() {
                s.$emit('resp',{ code: 1, message: 'Indicação incluída com sucesso' })
                s.saving = false
            }
            ).catch(function (error) {
                console.log(error);

                toast ({
                    type: VueNotifications.types.warn,
                    title: 'Indicação',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
                s.saving = false
            });
            
        },

       
        save() {
           
            var containsError = false

            if(!this.selectedItem.contactName || this.selectedItem.contactName == '') {
                containsError = true
                this.contactNameClass = 'is-invalid'
            }
            else {
                this.contactNameClass = ''
            }

            if(!this.selectedItem.serviceDescription || this.selectedItem.serviceDescription == '') {
                containsError = true
                this.serviceDescriptionClass = 'is-invalid'
            }
            else {
                this.serviceDescriptionClass = ''
            }

            if((!this.selectedItem.contactPhone || this.selectedItem.contactPhone == '') && (!this.selectedItem.contactEmail || this.selectedItem.contactEmail == '')) {
                containsError = true
                this.contactPhoneClass = 'is-invalid'
                this.contactEmailClass = 'is-invalid'
            }
            else {
                this.contactPhoneClass = ''
                this.contactEmailClass = ''
            }

            if(!containsError) {
                this.saveItem(this.selectedItem);
            }
           
        },

        async getGroupUser() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            this.isBusy = true;
         
            await axios.get(
                this.$store.state.ws_url + "/franchise/group/user/ddl?companyId=" + s.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function (resp) {
                s.groupUserDDL = resp.data.obj;
            }
            ).catch(function (error) {
                console.log(error.message);            
            });

            this.isBusy = false;
        
        }
    },
    mounted: function() {
        this.getGroupUser()
        this.tabInternalReferral = this.selectedItem.contactId && this.selectedItem.contactId > 0 ? 'I' : 'E'
    }
}
</script>